import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { HttpServiceDiary } from "src/app/services/Diary/http/http.service_Diary";
import { AppointmentData, InvalidResourceTime, NextSlotIn, StatusAppointment } from "src/classes/Diary/Appointment";
import { Config, ConfigDiary } from "src/classes/Common/ConfigData";
import { Service } from "src/classes/Diary/DepartmentsServices";
import { localeHe, MbscDateType, MbscEventcalendarOptions } from "@mobiscroll/angular";
import * as moment from "moment";
import { Duration } from "moment";

type Resource = {
    id: number;
    name: string;
    imagePath: string;
};

@Component({
    selector: "app-create-app-summary",
    templateUrl: "./create-app-summary.component.html",
    styleUrls: ["./create-app-summary.component.css"],
})
export class CreateAppSummaryComponent implements OnInit {
    @Input() appDataTemp: AppointmentData;
    @Input() config: Config;
    @Input() configDiary: ConfigDiary;
    @Input() holidayName: string;
    @Input() resources: Resource[];
    @Input() invalid: InvalidResourceTime[];
    @Input() isEditingEvent: boolean;
    @Input() isAppointorErrorVisible: boolean;

    @Output() eventTitleChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() isEditHoursChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild("summaryStep", { static: false }) summaryStep: ElementRef;

    startInvalid: InvalidResourceTime[] = [];
    endInvalid: InvalidResourceTime[] = [];

    statusesAppointment: StatusAppointment[];

    startTime: string;
    endTime: string;
    eventDuration: string;

    isEndTimeSettedNullNow: boolean = false;

    startTimepickerValue: MbscDateType;
    endTimepickerValue: MbscDateType;

    activeTimepicker: "start" | "end" = "start";

    isTimeEditing: boolean = false;

    selectedResource: Resource;
    selectedStatus: StatusAppointment;
    selectedAppointor: Resource;

    isResourceListOpened: boolean = false;
    isStatusListOpened: boolean = false;
    isAppointorListOpened: boolean = false;

    // Guard to ignore initial onChange from Mobiscroll picker
    private ignoreNextTimeChange: boolean = false;

    creationAppointor: Resource;

    options: MbscEventcalendarOptions = {
        locale: localeHe,
        theme: "windows",
        themeVariant: "light",
    };

    constructor(private httpService: HttpServiceDiary, private logger: NGXLogger) {}

    ngOnInit(): void {
        this.httpService.getStatusesApp().subscribe(
            (data: StatusAppointment[]): void => {
                this.statusesAppointment = [...data];

                console.log("Count of statusesApp for appointment: " + this.statusesAppointment.length);
                console.log(this.statusesAppointment);
            },
            (error) => {
                console.log(error);
                this.logger.error(
                    "user: " +
                        sessionStorage.getItem("email") +
                        ", component: " +
                        this.constructor.name +
                        ", error: " +
                        error.message
                );
            }
        );
    }

    // Function that works on the opening of this step
    initialize(isRedirectedFromServices: boolean = true): void {
        this.isResourceListOpened = false;
        this.isStatusListOpened = false;
        this.isAppointorListOpened = false;

        this.eventTitleChange.emit("סיכום תור");

        this.activeTimepicker = "start";
        this.isTimeEditing = false;
        this.isEditHoursChange.emit(false);

        this.selectedResource = (this.resources as Resource[]).find(
            (resource: Resource) => resource.id == this.appDataTemp.resourceId
        );
        this.selectedStatus = this.statusesAppointment.find(
            (status: StatusAppointment) => status.indEv == (this.appDataTemp.statusId || 4)
        );

        if (this.isEditingEvent) {
            this.selectedAppointor = (this.resources as Resource[]).find(
                (resource: Resource) => resource.id == this.appDataTemp.appointorId
            );
            this.creationAppointor = (this.resources as Resource[]).find(
                (resource: Resource) => resource.id == this.appDataTemp.creationAppointorId
            );
        } else {
            this.selectedAppointor = null;
            this.appDataTemp.remark = "";
        }

        this.appDataTemp.absenceId = null;

        this.startTime = moment(this.appDataTemp.start as Date).format("HH:mm");
        this.endTime = moment(this.appDataTemp.end as Date).format("HH:mm");

        // Filter the invalid times for the current resource and create the start and end invalid times
        this.invalid = this.invalid.filter((item: InvalidResourceTime) => item.resource == this.appDataTemp.resourceId);

        this.startInvalid = this.invalid.map((item: InvalidResourceTime) => ({
            start: item.start,
            end: moment(item.end, "HH:mm").add(-this.configDiary.calScaleInMin, "minute").format("HH:mm"),
            resource: item.resource,
        }));

        this.startInvalid.unshift({
            start: "00:00",
            end: moment(this.configDiary.fromHour, "HH:mm")
                .add(-this.configDiary.calScaleInMin, "minute")
                .format("HH:mm"),
            resource: this.appDataTemp.resourceId as number,
        });

        this.startInvalid.push({
            start: this.configDiary.toHour,
            end: "23:59",
            resource: this.appDataTemp.resourceId as number,
        });

        this.endInvalid.unshift({
            start: "00:00",
            end: this.startTime,
            resource: this.appDataTemp.resourceId as number,
        });

        // Find the first invalid time that is after the start time, if it does not exist, then the end time is the end of the working day
        for (let i = 0; i < this.invalid.length; i++) {
            const item: InvalidResourceTime = this.invalid[i];

            if (moment(item.start, "HH:mm").isAfter(moment(this.startTime, "HH:mm"))) {
                this.endInvalid.push({
                    start: moment(item.start, "HH:mm").add(this.configDiary.calScaleInMin, "minute").format("HH:mm"),
                    end: "23:59",
                    resource: this.appDataTemp.resourceId as number,
                });

                break;
            }
        }

        if (this.endInvalid.length == 1) {
            this.endInvalid.push({
                start: moment(this.configDiary.toHour, "HH:mm")
                    .add(this.configDiary.calScaleInMin, "minute")
                    .format("HH:mm"),
                end: "23:59",
                resource: this.appDataTemp.resourceId as number,
            });
        }

        let duration: Duration = moment.duration(moment(this.appDataTemp.end as Date).diff(this.appDataTemp.start));

        // If the event is redirected from the services, then the duration of the event will be equal to the duration of the services
        const servicesDuration: number = this.getServicesDuration();
        if (isRedirectedFromServices && duration.asMinutes() != servicesDuration && servicesDuration != 0) {
            const endTime: moment.Moment = moment(this.appDataTemp.start).add(servicesDuration, "minutes");
            const maxEndTime: moment.Moment = moment(this.appDataTemp.maxEventEndTime).minutes(
                Math.floor(moment(this.appDataTemp.maxEventEndTime).minutes() / this.configDiary.calScaleInMin) *
                    this.configDiary.calScaleInMin
            );

            endTime.minutes(
                Math.ceil(endTime.minutes() / this.configDiary.calScaleInMin) * this.configDiary.calScaleInMin
            );

            if (endTime.isAfter(maxEndTime)) {
                this.endTime = maxEndTime.format("HH:mm");
            } else {
                this.endTime = endTime.format("HH:mm");
            }

            duration = moment.duration(moment(this.endTime, "HH:mm").diff(moment(this.startTime, "HH:mm")));
        }

        this.eventDuration = duration.hours().toString() + " ש׳ " + duration.minutes().toString() + " דק׳";

        this.startTimepickerValue = this.startTime;
        this.endTimepickerValue = this.endTime;

        let [hours, minutes] = this.startTime.split(":").map(Number);
        (this.appDataTemp.start as Date).setHours(hours, minutes, 0);

        [hours, minutes] = this.endTime.split(":").map(Number);
        (this.appDataTemp.end as Date).setHours(hours, minutes, 0);
    }

    // Returns a link on the client image
    getClientImageSrc(): string {
        if (this.appDataTemp.customerapp && this.appDataTemp.customerapp.imagePath && this.config) {
            return (
                "https://optimusb12023.s3.eu-north-1.amazonaws.com/" +
                this.config.remotebusid +
                "/clients/" +
                this.appDataTemp.customerapp.customerId +
                "/" +
                this.appDataTemp.customerapp.imagePath
            );
        }

        return "assets/img/client-avatar.png";
    }

    // Deletes the client image
    clearImagePath(): void {
        this.appDataTemp.customerapp.imagePath = "";
    }

    // Function that opens the timepicker
    editTime(): void {
        this.startTimepickerValue = this.startTime;
        this.endTimepickerValue = this.endTime;

        // Ignore the initial onChange that Mobiscroll fires when picker renders
        this.ignoreNextTimeChange = true;

        this.chooseStartOrEndTimepicker("start");

        this.summaryStep.nativeElement.scrollTo({ top: 150, behavior: "smooth" });

        this.isTimeEditing = true;
        this.isEditHoursChange.emit(true);
    }

    // Sets the end time to null in the timepicker
    setEndTimeNull(): void {
        this.endTime = "בחר";
        this.endTimepickerValue = null;
        this.isEndTimeSettedNullNow = true;
    }

    // Function change the time selection mode, that indicates which timepicker is active
    chooseStartOrEndTimepicker(mode: "start" | "end"): void {
        // Ignore initial onChange when switching pickers
        this.ignoreNextTimeChange = true;
        this.activeTimepicker = mode;

        if (this.activeTimepicker == "end") {
            this.endInvalid = [
                {
                    start: "00:00",
                    end: this.startTime,
                    resource: this.appDataTemp.resourceId as number,
                },
            ];

            // Find the first invalid time that is after the start time, if it does not exist, then the end time is the end of the working day
            for (let i = 0; i < this.invalid.length; i++) {
                const item: InvalidResourceTime = this.invalid[i];

                if (moment(item.start, "HH:mm").isAfter(moment(this.startTime, "HH:mm"))) {
                    this.endInvalid.push({
                        start: moment(item.start, "HH:mm")
                            .add(this.configDiary.calScaleInMin, "minute")
                            .format("HH:mm"),
                        end: "23:59",
                        resource: this.appDataTemp.resourceId as number,
                    });

                    break;
                }
            }

            if (this.endInvalid.length == 1) {
                this.endInvalid.push({
                    start: moment(this.configDiary.toHour, "HH:mm")
                        .add(this.configDiary.calScaleInMin, "minute")
                        .format("HH:mm"),
                    end: "23:59",
                    resource: this.appDataTemp.resourceId as number,
                });
            }

            // If the end time is setted to null, then the end time will be the start time + the minimum duration of the event
            if (this.isEndTimeSettedNullNow) {
                this.endTimepickerValue = moment(this.startTime, "HH:mm")
                    .add(this.configDiary.calScaleInMin, "minute")
                    .format("HH:mm");
                this.endTime = this.endTimepickerValue as string;
                this.isEndTimeSettedNullNow = false;
            }

            // If the maximum end time is before the end timepicker value, then the end timepicker value will be the maximum end time
            if (
                moment(this.endInvalid[this.endInvalid.length - 1].start, "HH:mm").isBefore(
                    typeof this.endTimepickerValue == "string"
                        ? moment(this.endTimepickerValue, "HH:mm")
                        : moment(this.endTimepickerValue)
                )
            ) {
                this.endTimepickerValue = this.endInvalid[this.endInvalid.length - 1].start;
                this.endTime = this.endTimepickerValue as string;
            }
        }
    }

    // Function that works on the change of time
    onTimeChange(mode: "start" | "end"): void {
        // Skip initial onChange fired by Mobiscroll when picker renders
        if (this.ignoreNextTimeChange) {
            this.ignoreNextTimeChange = false;
            // Restore the correct value if Mobiscroll changed it
            if (mode === "start" && typeof this.startTimepickerValue !== "string") {
                this.startTimepickerValue = this.startTime;
            } else if (mode === "end" && typeof this.endTimepickerValue !== "string") {
                this.endTimepickerValue = this.endTime;
            }
            return;
        }

        if (mode == "start") {
            if (typeof this.startTimepickerValue == "string") {
                this.startTime = this.startTimepickerValue;
            } else {
                // If the start time is after the end time, then the end time will be setted to null
                if (
                    moment(this.startTimepickerValue).isSameOrAfter(
                        moment(
                            typeof this.endTimepickerValue == "string"
                                ? moment(this.endTimepickerValue, "HH:mm")
                                : moment(this.endTimepickerValue)
                        )
                    )
                ) {
                    this.setEndTimeNull();
                }

                // Check if the chosen start time does not intersect with the invalid times
                for (let i = 0; i < this.invalid.length; i++) {
                    const item: InvalidResourceTime = this.invalid[i];

                    if (
                        moment(item.start, "HH:mm").isBefore(
                            moment(
                                typeof this.endTimepickerValue == "string"
                                    ? moment(this.endTimepickerValue, "HH:mm")
                                    : moment(this.endTimepickerValue)
                            )
                        ) &&
                        moment(item.end, "HH:mm").isAfter(moment(this.startTimepickerValue))
                    ) {
                        this.endTimepickerValue = item.start as string;
                        this.endTime = this.endTimepickerValue;
                        break;
                    }
                }

                this.startTime = moment(this.startTimepickerValue).format("HH:mm");
            }
        } else if (mode == "end") {
            if (typeof this.endTimepickerValue == "string") {
                this.endTime = this.endTimepickerValue;
            } else {
                this.endTime = moment(this.endTimepickerValue).format("HH:mm");
            }
        }
    }

    // Function that saves the edited time and closes the timepicker
    saveEditedTime(): void {
        // If the end time is setted to null, then restore the previous values of the start and end times
        if (this.isEndTimeSettedNullNow) {
            this.startTime = moment(this.appDataTemp.start as Date).format("HH:mm");
            this.endTime = moment(this.appDataTemp.end as Date).format("HH:mm");
        } else {
            this.startTime =
                typeof this.startTimepickerValue == "string"
                    ? this.startTimepickerValue
                    : moment(this.startTimepickerValue).format("HH:mm");
            this.endTime =
                typeof this.endTimepickerValue == "string"
                    ? this.endTimepickerValue
                    : moment(this.endTimepickerValue).format("HH:mm");
        }

        const duration: moment.Duration = moment.duration(
            moment(this.endTime as string, "HH:mm").diff(moment(this.startTime, "HH:mm"))
        );

        this.eventDuration = duration.hours().toString() + " ש׳ " + duration.minutes().toString() + " דק׳";

        let [hours, minutes] = this.startTime.split(":").map(Number);
        (this.appDataTemp.start as Date).setHours(hours, minutes, 0);

        [hours, minutes] = this.endTime.split(":").map(Number);
        (this.appDataTemp.end as Date).setHours(hours, minutes, 0);

        this.startTimepickerValue = this.startTime;
        this.endTimepickerValue = this.endTime;

        const nextslotin: NextSlotIn = new NextSlotIn();
        nextslotin.saparId = this.appDataTemp.resourceId;
        nextslotin.startEvent = moment(this.appDataTemp.start).format("MM/DD/YYYY, HH:mm");

        this.httpService.getStartNextSlot(nextslotin).subscribe((data: string) => {
            this.appDataTemp.maxEventEndTime = data;
        });

        this.isTimeEditing = false;
        this.isEditHoursChange.emit(false);
    }

    // Function that cancels the time change and closes the timepicker
    closeEditingTime(): void {
        this.startTimepickerValue = moment(this.appDataTemp.start as Date).format("HH:mm");
        this.endTimepickerValue = moment(this.appDataTemp.end as Date).format("HH:mm");

        this.startTime = this.startTimepickerValue;
        this.endTime = this.endTimepickerValue;

        this.isEndTimeSettedNullNow = false;

        this.isTimeEditing = false;
        this.isEditHoursChange.emit(false);
    }

    // Returns the total price of the services
    getServicesPrice(): number {
        return this.appDataTemp.subserv.reduce(
            (accumulator: number, service: Service) => accumulator + +service.priceService,
            0
        );
    }

    // Returns the total duration of the services
    getServicesDuration(): number {
        return this.appDataTemp.subserv.reduce(
            (accumulator: number, service: Service) => accumulator + +service.timeService,
            0
        );
    }

    // Function that toggles a resource dropdown
    toggleResourceList(): void {
        this.isResourceListOpened = !this.isResourceListOpened;
    }

    // Function that toggles a status dropdown
    toggleStatusList(): void {
        this.isStatusListOpened = !this.isStatusListOpened;
    }

    // Function that toggles a appointer dropdown
    toggleAppointorList(): void {
        this.isAppointorListOpened = !this.isAppointorListOpened;
    }

    // Returns worker image link
    getResourceImage(imagePath: string): string {
        if (this.config) {
            return (
                "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/team/" + imagePath
            );
        }
    }

    // Function that saves changes to the resource dropdown
    chooseResource(resource: Resource): void {
        this.appDataTemp.resourceId = resource.id;
        this.selectedResource = resource;
        this.toggleResourceList();
    }

    // Function that saves changes to the status dropdown
    chooseStatus(status: StatusAppointment): void {
        this.appDataTemp.statusId = status.indEv;
        this.selectedStatus = status;
        this.toggleStatusList();
    }

    // Function that saves changes to the appointor dropdown
    chooseAppointor(appointor: Resource | null): void {
        if (!appointor) {
            this.appDataTemp.appointorId = null;
            this.selectedAppointor = null;
        } else {
            this.appDataTemp.appointorId = appointor.id;
            this.selectedAppointor = appointor;
        }

        this.toggleAppointorList();
    }

    scrollToAppointor(): void {
        setTimeout(() => {
            this.summaryStep.nativeElement.scrollTo({
                top: this.summaryStep.nativeElement.scrollHeight,
                behavior: "smooth",
            });
        }, 0);
    }
}
